import { render, staticRenderFns } from "./NewsTab.vue?vue&type=template&id=5e001c2b&scoped=true&"
import script from "./NewsTab.vue?vue&type=script&lang=js&"
export * from "./NewsTab.vue?vue&type=script&lang=js&"
import style0 from "./NewsTab.vue?vue&type=style&index=0&id=5e001c2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e001c2b",
  null
  
)

export default component.exports